module.exports = __webpack_public_path__ + "img/河南金彭车业有限公司.00d0daa1.jpg";